import { render, staticRenderFns } from "./SponsorsSettings.vue?vue&type=template&id=62409832&"
import script from "./SponsorsSettings.vue?vue&type=script&lang=js&"
export * from "./SponsorsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports